import React from "react";
import classNames from "classnames";
import type { BadgeProps } from "./types";
import styles from "./Badge.module.css";

/**
 * Badge component - A small label for status indicators, counts, or labels.
 * Supports multiple variants and sizes.
 */
export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  (
    {
      children,
      variant = "default",
      size = "md",
      dot = false,
      className,
      "data-testid": testId,
      ...rest
    },
    ref,
  ) => {
    return (
      <span
        ref={ref}
        className={classNames(
          styles.badge,
          styles[variant],
          styles[size],
          {
            [styles.dot]: dot,
          },
          className,
        )}
        data-testid={testId}
        {...rest}
      >
        {!dot && children}
      </span>
    );
  },
);

Badge.displayName = "Badge";

export default Badge;
